{
  " +{{petCount}} more": " +{{petCount}} more",
  "<0><0></0><1>via {callerContext ?? ''}</1></0>": "<0><0></0><1>via {callerContext ?? ''}</1></0>",
  "Answer": "Answer",
  "Call to": "Call to",
  "Close panel": "Close panel",
  "Head of Household": "Head of Household",
  "Household": "Household",
  "Ignore": "Ignore",
  "Incoming Call": "Incoming Call",
  "Individual": "Individual",
  "Next Call": "Next Call",
  "Previous Call": "Previous Call",
  "The phone number is associated with the following contacts:": "The phone number is associated with the following contacts:",
  "Unknown Caller": "Unknown Caller",
  "View contact": "View contact",
  "{{contactToShow}} + {{count}} Contact Matches_one": "{{contactToShow}} + {{count}} Contact Match",
  "{{contactToShow}} + {{count}} Contact Matches_other": "{{contactToShow}} + {{count}} Contact Matches",
  "{{count}} Contact Matches_one": "{{count}} Contact Match",
  "{{count}} Contact Matches_other": "{{count}} Contact Matches"
}
